import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function DOffcanvasBody({ children, className, style, }) {
    return (_jsx("div", { className: classNames('offcanvas-body', className), style: style, children: children }));
}
//# sourceMappingURL=DOffcanvasBody.js.map